export default __webpack_public_path__ + "static/media/info-green.78aaee3b.svg";